import { render, staticRenderFns } from "./organization-electronic-storage-view.vue?vue&type=template&id=eb5c3888"
import script from "./organization-electronic-storage-view.vue?vue&type=script&lang=js"
export * from "./organization-electronic-storage-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports